import React from 'react';
import { Students } from '../../helpers/schoolAssignPropTypes';

const TeamStatistics = (props) => {
  const { students } = props;
  const total = students.length;
  const girl = students.filter((student) => student.gender === '女性').length;
  const tech = students.filter((student) => student.tech === true).length;
  const junior = students.filter((student) => student.grade !== null && student.grade.indexOf('中') === 0).length;
  const high = students.filter((student) => student.grade !== null && student.grade.indexOf('高') === 0).length;

  if (total === 0) {
    return (<p className="team-number"><span className="number zero">0人</span></p>);
  }
  return (
    <p className="team-number">
      <span className="number">
        {total}
        人
      </span>
      <span className="detail">
        <font className="pink">
          [女]
          {girl}
        </font>
        {' '}
        [技]
        {tech}
        {' '}
        [中]
        {junior}
        {' '}
        [高]
        {high}
      </span>
    </p>
  );
};

TeamStatistics.propTypes = {
  students: Students.isRequired,
};

export default TeamStatistics;
